import { AddressFields } from 'addresses/enums';
import { ICountryAutocomplete } from 'addresses/types';

export const STATE_CODE_USA = 'US';
export const STATE_CODE_CANADA = 'CA';

export const COUNTRIES_WITH_STATES = [STATE_CODE_USA, STATE_CODE_CANADA];

export const DEFAULT_COUNTRY: ICountryAutocomplete = {
  abbreviation: 'US',
  name: 'United States',
};

export const DEFAULT_REQUIRED_FIELDS = [
  AddressFields.NAME,
  AddressFields.ZIP,
  AddressFields.COUNTRY,
];

export const postalCodeMap = {
  [STATE_CODE_USA]: /^\d{5}(?:[-\s]\d{4})?$/,
  [STATE_CODE_CANADA]: /^([a-zA-Z]\d[a-zA-Z])(?:\s?\d[a-zA-Z]\d)?$/,
};
